import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';

const style = { minWidth: 190 };

const EmptyTimeTooltip = ({ date }) => {
  const { t } = useTranslation();
  return (
    <div className="react-hint__content" style={style}>
      <p>
        <strong>{t('checkout.flight.emptytime.unknown')}.</strong>
        <br />
        {t('checkout.flight.emptytime.anyFlight')}
        <br />
        <span>{`${t('search.empty.departureText_package')} ${date}`}</span>
      </p>
    </div>
  );
};

EmptyTimeTooltip.propTypes = {
  date: PropTypes.string.isRequired,
};

export default EmptyTimeTooltip;
